import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from './../../../environments/environment';
import { AuthServiceZ } from '../../authentification/auth-service.service';

@Injectable()
export class MainSupportService {
  constructor(
    private httpClient: HttpClient,
    public authService: AuthServiceZ
  ) { }

  getTickets(params): any {
    return this.httpClient
      .get(environment.api.backendBase + '/tickets', { params })
      .toPromise();
  }

  getTicketsXls(params): any {
    return this.httpClient
      .get(environment.api.backendBase + '/tickets/xls', {
        params,
        observe: 'response',
        responseType: 'arraybuffer',
      })
      .toPromise();
  }

  getTicket(ticketId): any {
    return this.httpClient
      .get(environment.api.backendBase + `/tickets/${ticketId}`)
      .toPromise();
  }

  validateTicket(ticketId): any {
    return this.httpClient
      .post(environment.api.backendBase + `/tickets/${ticketId}/validate`, {})
      .toPromise();
  }

  addTicketMessage(ticketId, payload): any {
    return this.httpClient
      .post(
        environment.api.backendBase + `/tickets/${ticketId}/messages`,
        payload
      )
      .toPromise();
  }

  getTicketMessages(ticketId): any {
    return this.httpClient
      .get(environment.api.backendBase + `/tickets/${ticketId}/messages`, {})
      .toPromise();
  }

  toggleTicket(ticketId, payload): any {
    return this.httpClient
      .put(environment.api.backendBase + `/tickets/${ticketId}/toggle`, payload)
      .toPromise();
  }

  assignTicket(ticketId, payload): any {
    return this.httpClient
      .put(environment.api.backendBase + `/tickets/${ticketId}/assign`, payload)
      .toPromise();
  }

  transferTicket(ticketId): any {
    return this.httpClient
      .post(environment.api.backendBase + `/tickets/${ticketId}/transfer`, {})
      .toPromise();
  }

  addTicket(ticket): any {
    return this.httpClient.post(environment.api.support, ticket).toPromise();
  }

  addMessage(message): any {
    let url = '';
    if (this.authService?.credentials?.user?.userType == 'User') {
      url = environment.api.partnerMicroService + '/tickets' + '/messages';
    } else {
      url = environment.api.support + '/messages';
    }
    return this.httpClient.post(url, message).toPromise();
  }

  getMyTickets(data): any {
    let url = '';
    if (this.authService?.credentials?.user?.userType == 'User') {
      url = environment.api.partnerMicroService + '/tickets' + '/filter';
    } else {
      url = environment.api.support + '/filter';
    }
    return this.httpClient.post(url, data).toPromise();
  }

  getAdmins(): any {
    return this.httpClient
      .post(environment.api.user + '/filter/users/Admin', {
        group: 'Admin',
        limit: 90000,
      })
      .toPromise();
  }

  getAllAdminsNames(): Promise<any> {
    return this.httpClient
      .get(environment.api.user + '/admins/names')
      .toPromise()
      .then((response: any) => {
        // Handle both array and wrapped responses
        const data = Array.isArray(response) ? response : (response?.body || response?.data || []);
        if (!Array.isArray(data)) {
          return [];
        }
        // Filter out undefined/null items and sort safely
        return data
          .filter(item => item && item.name)
          .sort((a, b) => (a.name || '').localeCompare(b.name || ''));
      })
      .catch((err) => {
        console.error('Error in getAllAdminsNames:', err);
        return [];
      });
  }


  getAllBusinessNames(): Promise<any> {
    return this.httpClient
      .get(environment.api.user + '/businesses/names')
      .toPromise()
      .then((response: any) => {
        // Handle both array and wrapped responses
        const data = Array.isArray(response) ? response : (response?.body || response?.data || []);
        if (!Array.isArray(data)) {
          return [];
        }
        return data
          .filter((item) => item.nomCommercial)
          .sort((a, b) => a.nomCommercial.localeCompare(b.nomCommercial));
      })
      .catch((err) => {
        console.error('Error in getAllBusinessNames:', err);
        return [];
      });
  }
  
  

  getAllBusiness(): any {
    return this.httpClient
      .get(environment.api.backendBase + '/business')
      .toPromise();
  }
  
  id;
  updateTicket(data): any {
    let url = '';
    if (this.authService?.credentials?.user?.userType == 'User') {
      url = environment.api.partnerMicroService + '/tickets' + '/update';
    } else {
      url = environment.api.support + '/update';
    }
    console.log('service khadem', data);

    return this.httpClient.post(url, data).toPromise();
  }

  confirmChanges(data): any {
    let url = '';
    if (this.authService?.credentials?.user?.userType == 'User') {
      url = environment.api.partnerMicroService + '/tickets' + '/update';
    } else {
      url = environment.api.support + '/confirmChanges';
    }

    return this.httpClient.post(url, data).toPromise();
  }

  getOne(id): any {
    let url = '';
    if (this.authService?.credentials?.user?.userType == 'User') {
      url = environment.api.partnerMicroService + '/tickets';
    } else {
      url = environment.api.support;
    }

    return this.httpClient.get(url + '/' + id).toPromise();
  }

  getMessages(id): any {
    let url = '';
    if (this.authService?.credentials?.user?.userType == 'User') {
      url = environment.api.partnerMicroService + '/tickets';
    } else {
      url = environment.api.support;
    }

    return this.httpClient.get(url + '/messages/' + id).toPromise();
  }

  getTicketOfPackingSlip(pickUpJobId): any {
    const url =
      environment.api.partnerMicroService +
      '/tickets/packingSlip/' +
      pickUpJobId;
    return this.httpClient.post(url, {}).toPromise();
  }

  generateExcelOfTickets(query): any {
    return this.httpClient
      .post(environment.api.backendBase + '/tickets/ticketsInExecel', query, {
        responseType: 'arraybuffer',
      })
      .toPromise();
  }
}
